import { newContainedApi } from '@lune/auth/api/fetch'
import {
  type ApiKindAndUrl,
  type ApiUrlContainedCollectionActions,
  apiUrlContainedCollectionFactory
} from '@lune/common/api'
import { LoginPage, Root } from '../paths'
import { type Alias, AliasKey, aliasIdToString } from './types'
import { version } from './version'

const collectionApi = apiUrlContainedCollectionFactory<AliasKey, string>(
  version,
  Root,
  (groupId) => ['/groups', groupId, 'aliases'],
  (id) => ['/groups', ...aliasIdToString(id)]
)

export const collectionApiForTesting = collectionApi

const AliasApiUrl = (): {
  alias: ApiKindAndUrl<
    Alias,
    AliasKey,
    ApiUrlContainedCollectionActions<AliasKey, string>
  >
} => ({
  alias: {
    kind: '#alias',
    api: collectionApi
  }
})

interface NewGroupSpec {
  name: string
  email: string
  members: string[]
}

interface MoveAliasBody {
  id: string
  alias: string
  to: string
  newGroup?: NewGroupSpec
}

type AliasMethods = {
  enable: Record<string, never>
  disable: Record<string, never>
  move: MoveAliasBody
}

export const api = newContainedApi<Alias, AliasKey, string, AliasMethods>(
  AliasApiUrl().alias,
  LoginPage
)
